import React, { Fragment } from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { TOKEN } from '../../_helpers/token';
import Modal from 'react-modal';
import './style.css';
import { MDBCloseIcon } from "mdbreact"
import Select from 'react-select';
import '../users/style.css'




export class UserDetailsLuckNumber extends React.Component {
    constructor(props) {
        super(props);
        this.toggleModalCreate = this.toggleModalCreate.bind(this);

        this.columns = [

            {
                key: "monetary",
                TrOnlyClassName: 'tsc',
                text: "Total Stake",
                className: "tsc",
                align: "left"
            },
            {
                key: "frequency",
                TrOnlyClassName: 'tsc',
                text: "Plays",
                className: "tsc",
                align: "left"
            },
            {
                key: "monetary",
                TrOnlyClassName: 'tsc',
                text: "Total Wins",
                className: "tsc",
                align: "left"
            },
            {
                key: "mtimeCreated",
                TrOnlyClassName: 'tsc',
                text: "Date Join",
                className: "tsc",
                align: "left"
            },

            {
                key: "dates2",
                TrOnlyClassName: 'tsc',
                text: "Last Date Active",
                className: "tsc",
                align: "left"
            },


        ];




        this.columns3 = [
            // {
            //     key: "mlive",
            //     TrOnlyClassName: 'tsc',
            //     text: "Game",
            //     className: "tsc",
            //     align: "left"
            // },

            {
                key: "mreference",
                TrOnlyClassName: 'tsc',
                text: "gameID",
                className: "tsc",
                align: "left"
            },

            {
                key: "transaction_id",
                TrOnlyClassName: 'tsc',
                text: "TransactionID",
                className: "tsc",
                align: "left"
            },
            {
                key: "stake_amount",
                TrOnlyClassName: 'tsc',
                text: "Stake",
                className: "tssc",
                align: "left"
            },
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "TimeStamp",
                className: "tsc",
                align: "left"
            },

        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: true,
            show_pagination: false,
            pagination: 'basic',
            page_size: 10,
            show_info: false,
            show_length_menu: false,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Enter GameID"
            }
        }


        this.configs = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: false,
            pagination: 'basic',
            page_size: 10,
            show_info: false,
            show_length_menu: false,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Enter GameID"
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            mdata: [],
            ddata: [],
            oncall: true,
            call_status: "On Call",
            remarks: "Pending",
            isOpen: false,
            isOpenModel: false,
            call_value: [
                { value: 'On Call', label: 'On Call' }],

            remark_value: [

                { value: 'Pending', label: 'Pending' }],

        };
    }

    toggleModalCreate = e => {
        this.setState({
            isOpen: true,
        });
    };

    closeModalUpload = e => {
        this.setState({
            isOpen: false,
        });
    };


    getData = (queryString = '') => {
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };

        let url = baseURL + `lucky_deposit_all?msisdn=${localStorage.getItem("phone")}&${queryString}`
        // alert(url)
        axios.get(url, axiosConfig, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then((branchResponse) => {
                this.setState({
                    adminss: branchResponse.data,
                    isLoading: false,
                }, function () {
                    // alert(JSON.stringify(branchResponse.data))
                    var data = [];
                    if (this.state.adminss.length > 0) {
                        for (let i = 0; i < this.state.adminss.length; i++) {
                            let date = { dates: moment(this.state.adminss[i].last_play_time).utc().format("DD-MMM-yyyy HH:mm:ss") };
                            let mlive = { mlive: this.state.adminss[i].game }
                            if (this.state.adminss[i].game == 'Live') {
                                mlive = { mlive: "PowerBox Live" };
                            }
                            data.push(Object.assign(date, mlive, this.state.adminss[i]));
                            this.setState({
                                ddata: data
                            })
                        }
                    } else {
                        this.setState({
                            ddata: data
                        })
                    }
                });
            })
    }



    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString)


    }

    componentDidMount() {

        this.getData()
        this.setState({ isLoading: true });
        axios.get(baseURL + 'customersonelucky/' + localStorage.getItem("phone"), {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then((response) => {
                console.log("bayo", response.data)
                this.setState({
                    admins: response.data.data,
                    isLoading: false
                },
                    function () {
                        var data = [];
                        let mbalance;
                        localStorage.setItem('customerID', this.state.admins.id)
                        let dates = { dates2: moment.utc(this.state.admins.last_transaction_time).format('DD MMM, YYYY HH:mm') };
                        let mtimeCreated = { mtimeCreated: moment.utc(this.state.admins.date_created).format('DD MMM, YYYY HH:mm') };

                        data.push(Object.assign(mtimeCreated, mbalance, dates, this.state.admins));
                        this.setState({
                            mdata: data,
                            number: this.state.admins.msisdn
                        })
                    }
                );
            })


    }



    handleChange = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    call_status: value.value.toString(),
                    call_value: [
                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };

    handleChangeMessage = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }


    handleChangeRemarks = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    remarks: value.value.toString(),
                    remark_value: [

                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };

    handleChangeCallType = value => {
        if (value != null) {
            this.setState(
                {
                    call_type: value.value.toString(),
                    call_type_value: [{ value: value.value.toString(), label: value.value.toString() }]
                });
        }
    };


    render() {
        // console.log("Load", isLoading);
        return (
            <div>
                <>
                    <Col md={12}>
                        <h4>LuckyUser <b>{localStorage.getItem("phone")}</b></h4><br />
                    </Col>
                    <Col md={12} lg={12} >
                        < Card >
                            <CardBody >
                                <div className="panel-body" >
                                    <Link to="/user_search">
                                        <Button className="pull-right"
                                            color="primary" outline>Go Back</Button><br /> <br /><br />
                                    </Link>
                                    {this.state.isShowError ?
                                        <div className="alert alert-success" >
                                            {this.state.statusMessage}
                                        </div> : null
                                    }
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="col-md-8 offset-md-2">

                                                <Link to="/user_details_lucky_withdrawal">
                                                    <Button className=""
                                                        color="primary" outline> PayOuts </Button><br /> <br /><br />
                                                </Link>
                                                <Link to="/all_message_all">
                                                    <Button className=""
                                                        color="primary" outline>Messages </Button><br /> <br /><br />
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="col-md-8">

                                            < ReactDatatable config={this.configs}
                                                records={this.state.mdata}
                                                id="tsc"
                                                columns={this.columns}
                                                loading={this.state.isLoading}
                                                extraButtons={this.extraButtons}
                                            />

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4><b>Last 10 Games</b></h4>
                                                </div>
                                                <div className="col-md-6">

                                                    <Link to="/user_details_lucky_deposit">
                                                        <Button className=""
                                                            color="primary" outline>More </Button><br /> <br /><br />
                                                    </Link>
                                                </div>
                                            </div>
                                            < ReactDatatable config={this.config}
                                                records={this.state.ddata}
                                                id="tsc"
                                                dynamic={true}
                                                loading={this.state.isLoading}
                                                onChange={this.tableChangeHandler}
                                                columns={this.columns3}
                                            />

                                        </div></div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </>
            </div>
        )
    }
}